import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BIZFLEX_FEATURE_KEY, BizflexState } from './bizflex.reducer';

// Lookup the 'Bizflex' feature state managed by NgRx
export const getBizflexState = createFeatureSelector<BizflexState>(BIZFLEX_FEATURE_KEY);
export const getAccessToken = createSelector(getBizflexState, state => state.accessToken);
export const getSignToken = createSelector(getBizflexState, state => state.signToken);
export const getJwt = createSelector(getBizflexState, state => state.jwt);
export const getApplicationId = createSelector(getBizflexState, state => state.applicationId);
export const getCompany = createSelector(getBizflexState, state => state.company);
export const getCurrencyCode = createSelector(getBizflexState, state => state.currencyCode);
export const getDirector = createSelector(getBizflexState, state => state.director);
export const getDirectors = createSelector(getBizflexState, state => state.directors);
export const getLoanCalculator = createSelector(getBizflexState, state => state.loanCalculator);
export const getLeadSubmissionToken = createSelector(getBizflexState, state => state.leadSubmissionToken);
export const getLeadSubmission = createSelector(getBizflexState, state => state.leadSubmission);
